import { colors } from '../../../shared/styles/baseStyle';

export const inputItem = { borderRadius: 8 };
export const buttonItem = { marginTop: 32, marginBottom: 0 };
export const button = {
  color: 'white',
  border: 'none',
  borderRadius: 8,
  fontWeight: 600
};
export const cancelButtonRow = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 8
};
export const cancelButton = {
  color: colors.anytimeBlue,
  padding: 4,
  height: 'auto',
  fontWeight: 'bold'
};
